import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))
const Show = React.lazy(() => import('./Show'))

export default {
  path: '/:channel/planner',
  name: 'Planner',
  component: Layout,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'show/:id', name: 'Show', component: Show },
  ],
};



// WEBPACK FOOTER //
// ./src/features/planner/route.js